<template>
  <div>
    <header class="atb">
      <div class="container-fluid">
        <div class="d-flex align-items-center flex-wrap flex-md-nowrap position-relative">
          <!-- <div class="logo" @click="gohome"></div> -->
          <logo />
          <!-- <div class="flag" @click="show_language_selector=!show_language_selector"></div>
              <div class="flag-dd" v-if="show_language_selector">
                  <div class="dropdown-menu dropdown-with-icons show"><a href="/en" class="dropdown-item"> en </a><a href="/ru" class="dropdown-item"> ru </a><a href="/cn" class="dropdown-item"> cn </a></div>
              </div> -->
          <nav class="navbar navbar-expand-lg ml-auto p-0 w-100">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto" style="display: none">
                <li class="nav-item">
                  <router-link
                    :to="{ name: 'comply-advantage-index' }"
                    class="nav-link"
                    >{{ $t("message.menu.monitoring") }}</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    :to="{ name: 'find-partner-info' }"
                    class="nav-link"
                    >{{ $t("message.menu.find_partner") }}</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link :to="{ name: 'business-note' }" class="nav-link">
                    {{ $t("message.menu.business_note") }}</router-link
                  >
                </li>
                <!-- <li class="nav-item">
                              <router-link :to="{name: 'contracts-index'}" class="nav-link">Контракты</router-link>
                          </li>
                          <li class="nav-item">
                              <router-link :to="{name: 'deals-index'}" class="nav-link">Сделки</router-link>
                          </li> -->
                <li class="nav-item">
                  <router-link :to="{ name: 'home' }" class="nav-link">{{
                    $t("message.menu.education")
                  }}</router-link>
                </li>
                <li class="nav-item">
                  <router-link
                    :to="{ name: 'sign-in' }"
                    class="nav-link text-primary"
                    >{{ $t("message.menu.signin") }}</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    :to="{ name: 'sign-up' }"
                    class="nav-link text-white btn btn-pill btn-primary"
                    >{{ $t("message.menu.register") }}</router-link
                  >
                </li>
              </ul>

              <ul class="navbar-nav ml-auto align-items-center">
                <notifications-top :in_menu="true"></notifications-top>
                <li class="dropdown nav-item ml-3">
                  <a
                    href="#"
                    class="dropdown-toggle- nav-link text-nowrap d-flex align-items-center"
                    data-toggle="dropdown"
                  >
                    <img
                      :src="avatar"
                      class="img-thumb rounded-circle mr-2"
                      style="height: 40px; width: 40px; object-fit: cover"
                      alt=""
                    />
                    <span style="color: #04416d" class="mr-3">
                      {{ username }}
                    </span>
                    <svg
                      width="14"
                      height="8"
                      viewBox="0 0 14 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13.7071 0.292893C14.0976 0.683418 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976315 1.31658 -0.0976315 0.683417 0.292893 0.292893C0.683417 -0.0976317 1.31658 -0.0976317 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976312 13.3166 -0.0976311 13.7071 0.292893Z"
                        fill="#47B2E4"
                      />
                    </svg>
                    <!-- <span>{{$t('message.help.pa_personal')}}</span> -->
                  </a>
                  <div class="dropdown-menu dropdown-with-icons">
                    <router-link
                      :to="{ name: 'account' }"
                      @click="show_menu = false"
                      class="dropdown-item"
                    >
                      {{ $t("message.menu.account") }}
                    </router-link>

                    <router-link
                      v-if="isAdmin"
                      @click="show_menu = false"
                      :to="{ name: 'admin-index' }"
                      class="dropdown-item"
                    >
                      {{ $t("message.admin.index") }}
                    </router-link>
                    <span
                      @click="logoutInit"
                      class="dropdown-item"
                      style="cursor: pointer"
                    >
                      {{ $t("message.menu.logout") }}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
          <button
            class="navbar-toggler position-absolute right-20 top-20 d-block d-md-none"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i class="fa fa-bars"></i>
          </button>

          <div class="collapse navbar-collapse"></div>
        </div>
      </div>
    </header>
    <nav
      style="display: none"
      class="navbar navbar-expand-lg pt-4 px-0 collapse-sm"
      :class="[
        show_title ? 'magoc-navbar navbar-light' : 'navbar-dark bg-info mb-5',
        show_menu ? 'show' : '',
      ]"
      color-on-scroll="100"
      id="sectionsNav"
    >
      <div class="container-fluid">
        <div
          class="d-flex justify-content-between navbar-translate px-3 w-100 px-lg-0"
        >
          <router-link class="navbar-brand1" :to="{ name: 'home' }">
            <svg
              data-v-018d4501=""
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 97.76 27.06"
              style="width: 85px"
            >
              <path
                data-v-018d4501=""
                d="M46.55,21.81H40.91l-1,3.19h-4.4L41.79,7.94h3.87L52,25H47.54ZM41.9,18.64h3.66l-1.84-5.92Zm23.3-7.53H60.08V25H56V11.11h-5V7.94H65.2Zm15.33,0H75.41V25H71.3V11.11h-5V7.94H80.53ZM86.66,25h-4.1V7.94h4.1Zm11.66-4.54a1.66,1.66,0,0,0-.64-1.4,7.49,7.49,0,0,0-2.24-1A21,21,0,0,1,92.81,17c-2.21-1.08-3.31-2.58-3.31-4.47a4,4,0,0,1,.82-2.5,5.26,5.26,0,0,1,2.34-1.69,9.15,9.15,0,0,1,3.4-.61,7.83,7.83,0,0,1,3.29.66,5.23,5.23,0,0,1,2.28,1.87,4.86,4.86,0,0,1,.8,2.77h-4.1a2.06,2.06,0,0,0-.64-1.62A2.48,2.48,0,0,0,96,10.81a2.8,2.8,0,0,0-1.75.49,1.48,1.48,0,0,0-.63,1.23,1.51,1.51,0,0,0,.7,1.2,9.06,9.06,0,0,0,2.47,1.1,14.56,14.56,0,0,1,2.91,1.22,4.87,4.87,0,0,1,2.76,4.39A4.18,4.18,0,0,1,100.75,24a7.53,7.53,0,0,1-4.63,1.27,9.31,9.31,0,0,1-3.76-.73,5.73,5.73,0,0,1-2.53-2,5.34,5.34,0,0,1-.85-3h4.13a2.66,2.66,0,0,0,.7,2,3.41,3.41,0,0,0,2.31.64,2.62,2.62,0,0,0,1.6-.43A1.47,1.47,0,0,0,98.32,20.46Z"
                transform="translate(-4.68 -2.94)"
              ></path>
              <path
                data-v-018d4501=""
                d="M16.57,3,21.9,5.4V18.51l-5.33,2.95Z"
                transform="translate(-4.68 -2.94)"
              ></path>
              <path
                data-v-018d4501=""
                d="M14.47,23.47V30L5.06,25l-.38-6.74Z"
                transform="translate(-4.68 -2.94)"
              ></path>
              <path
                data-v-018d4501=""
                d="M14.41,14.94v6.61L5.06,16.29V9.89Z"
                transform="translate(-4.68 -2.94)"
              ></path>
              <path
                data-v-018d4501=""
                d="M25.8,24.9l-9.29,5V23.42l9.29-5.08Z"
                transform="translate(-4.68 -2.94)"
              ></path>
              <path
                data-v-018d4501=""
                d="M14.35,13,8.43,10l.28-4.46,5.64-2.55Z"
                transform="translate(-4.68 -2.94)"
              ></path>
            </svg>
          </router-link>
          <div class="d-flex">
            <notifications-top :in_menu="false"></notifications-top>
            <button
              data-target="navbarNavDropdown"
              @click="show_menu = !show_menu"
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="bars"
                class="svg-inline--fa fa-bars fa-w-14"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path
                  fill="#ffffff"
                  d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                ></path>
              </svg>
              <!-- <span class="navbar-toggler-icon"></span>
                    <span class="navbar-toggler-icon"></span>
                    <span class="navbar-toggler-icon"></span> -->
            </button>
          </div>
        </div>

        <div
          class="collapse navbar-collapse"
          :class="show_menu ? 'show' : ''"
          id="navbarNavDropdown"
        >
          <ul class="navbar-nav ml-auto px-4 px-lg-0" v-if="!isAuthed">
            <!-- <li class="nav-item d-none">
                  <a href="#" class="nav-link text-nowrap">
                    {{$t('message.menu.customers')}}
                  </a>
                </li>
                <li class="nav-item d-none">
                  <a href="#" class="nav-link text-nowrap">
                    {{$t('message.menu.partners')}}
                  </a>
                </li>
                <li class="nav-item d-none">
                  <a href="#" class="nav-link text-nowrap">
                    {{$t('message.menu.events')}}
                  </a>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link text-nowrap" to="about">
                    {{$t('message.menu.about')}}
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link text-nowrap" to="project">
                    {{$t('message.menu.project')}}
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link text-nowrap" to="management">
                    {{$t('message.menu.board')}}
                  </router-link>
                </li>
                <li class="nav-item d-none">
                  <a href="#" class="nav-link text-nowrap">
                    {{$t('message.menu.services')}}
                  </a>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link text-nowrap" to="contacts">
                    {{$t('message.menu.contacts')}}
                  </router-link>
                </li> -->
            <li class="nav-item">
              <router-link
                class="nav-link text-nowrap"
                @click="show_menu = false"
                :to="{ name: 'homepage-index' }"
              >
                {{ $t("message.menu.home") }}
              </router-link>
            </li>
          </ul>
          <ul
            class="bg-sm-info navbar-nav ml-auto px-4 px-lg-0"
            v-if="isAuthed"
          >
            <li name="partners-nav-link" class="nav-item">
              <router-link
                :to="{ name: 'comply-advantage-index' }"
                @click="show_menu = false"
                class="nav-link text-nowrap pl-0"
              >
                <!-- {{$t('message.menu.comply_advantage')}} -->
                {{ $t("message.menu.monitoring") }}
              </router-link>
            </li>

            <li name="partners-nav-link" class="nav-item">
              <router-link
                :to="{
                  name: 'find-partner-info',
                  params: { services: ['886'], prices: {}, currency: {} },
                }"
                @click="show_menu = false"
                class="nav-link text-nowrap pl-0"
              >
                {{ $t("message.menu.find_partner") }}
              </router-link>
            </li>

            <li name="partners-nav-link" class="nav-item">
              <router-link
                :to="{
                  name: 'business-note',
                  params: {
                    services: ['430', '930', '701', '213', '736'],
                    prices: {},
                    currency: {},
                  },
                }"
                @click="show_menu = false"
                class="nav-link text-nowrap pl-0"
              >
                {{ $t("message.menu.business_note") }}
              </router-link>
            </li>

            <li name="contracts-nav-link" class="nav-item" v-if="is_contracts">
              <router-link
                :to="{ name: 'contracts-index' }"
                @click="show_menu = false"
                class="nav-link text-nowrap pl-0"
              >
                {{ $t("message.menu.orders") }}
              </router-link>
            </li>
            <li class="nav-item" v-if="is_contracts">
              <router-link
                :to="{ name: 'deals-index' }"
                @click="show_menu = false"
                class="nav-link text-nowrap pl-0"
              >
                {{ $t("message.menu.deals") }}
              </router-link>
            </li>
            <!-- <li class="nav-item">
                  <router-link :to="{name: 'archive-index'}" @click="show_menu = false" class="nav-link text-nowrap pl-0">
                    {{$t('message.menu.archive')}}
                  </router-link>
                </li> -->
            <!-- <li class="nav-item">
                  <router-link v-if="isTwh" :to="{name: 'twh-index'}" @click="show_menu = false" class="nav-link text-nowrap pl-0">
                    {{$t('message.menu.twh')}}
                  </router-link>
                </li> -->
            <!-- <top-balance /> -->
            <li name="partners-nav-link" class="nav-item">
              <router-link
                class="nav-link text-nowrap pl-0"
                v-tippy="{ arrow: true, theme: 'light-border' }"
                :content="$t('message.account.topup_account')"
                :to="{ name: 'account' }"
              >
                <!-- <i class="fa fa-file-invoice-dollar"></i> -->
                Баланс
              </router-link>
            </li>
            <li name="partners-nav-link" class="nav-item">
              <a
                class="nav-link text-nowrap pl-0"
                @click="gotosection('learning')"
                style="cursor: pointer"
              >
                <!-- <i class="fa fa-file-invoice-dollar"></i> -->
                Обучение
              </a>
            </li>
            <notifications-top :in_menu="true"></notifications-top>
            <li class="dropdown nav-item">
              <a
                href="#"
                class="dropdown-toggle nav-link text-nowrap d-flex align-items-center"
                data-toggle="dropdown"
              >
                <i class="far fa-user-circle"></i>
                <span>{{ $t("message.help.pa_personal") }}</span>
              </a>
              <div class="dropdown-menu dropdown-with-icons">
                <router-link
                  :to="{ name: 'account' }"
                  @click="show_menu = false"
                  class="dropdown-item"
                >
                  {{ $t("message.menu.account") }}
                </router-link>

                <router-link
                  v-if="isAdmin"
                  @click="show_menu = false"
                  :to="{ name: 'admin-index' }"
                  class="dropdown-item"
                >
                  {{ $t("message.admin.index") }}
                </router-link>
                <span
                  @click="logoutInit"
                  class="dropdown-item"
                  style="cursor: pointer"
                >
                  {{ $t("message.menu.logout") }}
                </span>
              </div>
            </li>
          </ul>
          <ul class="bg-sm-info navbar-nav ml-auto px-4 px-lg-0">
            <li class="nav-item d-flex align-items-center" v-if="!isAuthed">
              <router-link
                id="sign-in-button"
                @click="show_menu = false"
                :to="{ name: 'sign-in' }"
                class="nav-link text-nowrap"
              >
                <i class="far fa-user-circle"></i>
                {{ $t("message.menu.signin") }}
              </router-link>
              <span>|</span>
              <router-link
                id="register-button"
                @click="show_menu = false"
                :to="{ name: 'sign-up' }"
                class="nav-link text-nowrap"
              >
                {{ $t("message.menu.register") }}
              </router-link>
            </li>
            <!-- <help-selector :page="$route.name"></help-selector> -->
            <li class="dropdown nav-item">
              <a
                href="#"
                class="dropdown-toggle nav-link text-nowrap"
                data-toggle="dropdown"
              >
                <i class="far fa-flag"></i> {{ $i18n.locale }}
              </a>
              <div class="dropdown-menu dropdown-with-icons">
                <a href="/en" class="dropdown-item"> en </a>
                <a href="/ru" class="dropdown-item"> ru </a>
                <a href="/cn" class="dropdown-item"> cn </a>
              </div>
            </li>
            <!-- <full-screen></full-screen> -->
            <!-- <li class="nav-item">
                    <a class="nav-link" rel="tooltip" title="" data-placement="bottom" href="https://www.facebook.com/" target="_blank" data-original-title="Like us on Facebook">
                      <i class="fab fa-facebook-square"></i>
                    </a>
                  </li> -->
          </ul>
        </div>
      </div>
      <b-modal
        id="time-to-logout"
        size="sm"
        :title="$t('message.login_form.time_to_logout_title')"
        :hide-footer="true"
        button-size="lg"
      >
        <p>{{ $t("message.login_form.time_to_logout_description") }}</p>
        <button
          class="btn btn-pills btn-round btn-success"
          @click="$bvModal.hide('time-to-logout')"
        >
          {{ $t("message.close") }}
        </button>
      </b-modal>
    </nav>
  </div>
</template>
<script>
import helpSelector from "./help/help-selector.vue";
import topBalance from "./partials/top-balance.vue";
export default {
  components: { helpSelector, topBalance },
  computed: {
    avatar() {
      if (this.image !== false) return this.image;
      if (this.$store.state.firmfull && this.$store.state.firmfull.persons)
        return this.$store.state.firmfull.persons.avatar
          ? this.$store.state.firmfull.persons.avatar
          : "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wCEAAQEBAQEBAUFBQUHBwYHBwoJCAgJCg8KCwoLCg8WDhAODhAOFhQYExITGBQjHBgYHCMpIiAiKTEsLDE+Oz5RUW0BBAQEBAQEBQUFBQcHBgcHCgkICAkKDwoLCgsKDxYOEA4OEA4WFBgTEhMYFCMcGBgcIykiICIpMSwsMT47PlFRbf/CABEIAFAAUAMBEQACEQEDEQH/xAAtAAEAAwEBAQEAAAAAAAAAAAAAAQQFBgIDCAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAA/fwPJknoHk1yQCiZZsFoFQyDVLp5OfB0JIBzoOgMkqknQEgg54ForEA6IAHOgkEAuGsDIKgJLJVPuaRZBWM0+BaNcEgAAgEggkAEAkAgAAEg/8QALhAAAQMDAQUHBAMAAAAAAAAAAQIDEQAEEDEFEhMhUSAiQWFxgaEUMlJiI0LB/9oACAEBAAE/AMXO0W2pS33lfAp29uHTzXA6DlSLO6dTvbpjzNLs7pkb26Y8jTV7cNHkskdDzq32i07CV9xXwexfXpWS00YSNT1xs21ChxlifxH+52lapR/MjlJ7wxZXxQQ24ZSdD0xtG44TXDSe8r4GWAAy2P1GbgSw4P1OdnXHFb4avuR8ir10u3Kz4AwPbAiRNJASABoBlQCkkHQijiycLVyg9TB96Jkk5sn+MzEQUwDm+f4LMASVyBkGCDREEjNi6pu4TGiuRzeuKcuFzokwMgSQKvWy1crHUyPfCLZ9z7WzVpYLbWHHSBGgzd7OWtZcaIM6g0u2fb+5tWLJou3CB4AyfatoW4dQHBqjXzFNIaSkFsCCNe2620tJLgEda2fbBpBWRzVpPTBSq1UVJBLR1H4+YoEKAIMjskhIkmBQBuVBShutJ0H5dgslJKmlbp8R4GuM4jk40fVPeFfUseK49RFfUseC59BNcZxfJto+qu6KSxJCnVb5Gg/qM//EABQRAQAAAAAAAAAAAAAAAAAAAGD/2gAIAQIBAT8ASf/EABQRAQAAAAAAAAAAAAAAAAAAAGD/2gAIAQMBAT8ASf/Z";
      return "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wCEAAQEBAQEBAUFBQUHBwYHBwoJCAgJCg8KCwoLCg8WDhAODhAOFhQYExITGBQjHBgYHCMpIiAiKTEsLDE+Oz5RUW0BBAQEBAQEBQUFBQcHBgcHCgkICAkKDwoLCgsKDxYOEA4OEA4WFBgTEhMYFCMcGBgcIykiICIpMSwsMT47PlFRbf/CABEIAFAAUAMBEQACEQEDEQH/xAAtAAEAAwEBAQEAAAAAAAAAAAAAAQQFBgIDCAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAA/fwPJknoHk1yQCiZZsFoFQyDVLp5OfB0JIBzoOgMkqknQEgg54ForEA6IAHOgkEAuGsDIKgJLJVPuaRZBWM0+BaNcEgAAgEggkAEAkAgAAEg/8QALhAAAQMDAQUHBAMAAAAAAAAAAQIDEQAEEDEFEhMhUSAiQWFxgaEUMlJiI0LB/9oACAEBAAE/AMXO0W2pS33lfAp29uHTzXA6DlSLO6dTvbpjzNLs7pkb26Y8jTV7cNHkskdDzq32i07CV9xXwexfXpWS00YSNT1xs21ChxlifxH+52lapR/MjlJ7wxZXxQQ24ZSdD0xtG44TXDSe8r4GWAAy2P1GbgSw4P1OdnXHFb4avuR8ir10u3Kz4AwPbAiRNJASABoBlQCkkHQijiycLVyg9TB96Jkk5sn+MzEQUwDm+f4LMASVyBkGCDREEjNi6pu4TGiuRzeuKcuFzokwMgSQKvWy1crHUyPfCLZ9z7WzVpYLbWHHSBGgzd7OWtZcaIM6g0u2fb+5tWLJou3CB4AyfatoW4dQHBqjXzFNIaSkFsCCNe2620tJLgEda2fbBpBWRzVpPTBSq1UVJBLR1H4+YoEKAIMjskhIkmBQBuVBShutJ0H5dgslJKmlbp8R4GuM4jk40fVPeFfUseK49RFfUseC59BNcZxfJto+qu6KSxJCnVb5Gg/qM//EABQRAQAAAAAAAAAAAAAAAAAAAGD/2gAIAQIBAT8ASf/EABQRAQAAAAAAAAAAAAAAAAAAAGD/2gAIAQMBAT8ASf/Z";
    },
    username() {
      if (this.$store.state.firmfull && this.$store.state.firmfull.persons)
        return this.$store.state.firmfull.persons.given_name
          ? this.$store.state.firmfull.persons.given_name +
              " " +
              this.$store.state.firmfull.persons.last_name
          : this.$t("message.help.pa_personal");
      return this.$t("message.help.pa_personal");
    },
    is_domain_kz() {
      return (
        window.location.hostname == "attistrade.kz" ||
        window.location.hostname == "dev.attistrade.kz" ||
        window.location.hostname == "localhost"
      );
    },
    show_title() {
      if (
        this.$route.name == "home" ||
        this.$route.name == "home-after-reg" ||
        this.$route.name == "home-after-login"
      )
        return true;
      else return false;
    },
    isAuthed() {
      return this.$store.state.auth;
    },
    //checks if user is admin (has role 63)
    isAdmin() {
      return this.$store.state.user.role_id == 63;
    },
    isTwh() {
      if (window.dev_mode) return true;
      // return true
      let has_role = false;
      this.$store.state.user.Roles.forEach((item) => {
        if (item == "twh") has_role = true;
      });
      if (!has_role && this.$store.state.user.role_id == 8) has_role = true;
      return has_role;
    },
  },
  data() {
    return {
      show_menu: false,
      is_contracts: false,
      image: false,
    };
  },
  mounted() {
    this.show_menu = false;
    this.$root.$on("contractMenuChanged", () => {
      this.fetchIfIsContractsMenu();
    });
    this.$root.$on("change-avatar", (image) => {
      this.image = image.avatar;
    });
    this.fetchIfIsContractsMenu();
    this.$root.$on("logout", () => {
      this.logout();
      this.gototo("sign-in");
    });
    this.$root.$on("time-to-logout", () => {
      if (this.isAuthed === true) this.$bvModal.show("time-to-logout");
    });
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId === "time-to-logout" && this.isAuthed === true) {
        // window.updateToken();
        this.$root.$emit("logout");
        this.$router.push({ name: "sign-in" });
        // this.$store.commit('logout')
        // axios.get(window.base + '/account/logout')
        // window.location.reload()
      }
    });
  },
  methods: {
    gohome() {
      this.$router.push({ name: "home" });
    },
    fetchIfIsContractsMenu() {
      let status = localStorage.getItem("attis-contracts");
      if (status == null) status = "0";
      this.is_contracts = parseInt(status);
    },
    gotosection(l) {
      if (l == "learning")
        window.scrollTo(0, document.querySelector("#learning").offsetTop);
    },
    show_menu_action() {
      if (this.show_menu) this.show_menu = false;
      else this.show_menu = true;
    },
    gototo(name, param) {
      this.show_menu = false;
      this.$router.push({ name: name, params: param });
    },
    logoutInit() {
      this.$root.$emit("logout");
    },
    logout() {
      this.show_menu = false;
      this.$store.commit("logout");
      // window.updateToken()
      axios.get(window.base + "/account/logout").then(() => {
        window.updateToken();
      });
      this.$router.push({ name: "home" });
    },
  },
};
</script>
<style>
@media screen and (max-width: 768px) {
  .bg-sm-info {
    background-color: #00b8d8 !important;
  }
}
.navbar-light a {
  color: #04416d !important;
}
.navbar-brand1 {
  color: #04416d !important;
}
</style>

<style scoped>
:root {
  font-family: "Roboto", sans-serif;
}
header {
  /* primary100 */
  padding: 4px 0;
  background: #ffffff;
  box-shadow: 0px 4px 60px rgba(0, 38, 66, 0.1);
  position: relative;
  z-index: 2;
  border-radius: 0px 0px 20px 20px;
}
.container {
  max-width: 1220px;
}
/* header .logo{
	    width: 127px;
        height: 32px;
        background-image: url("data:image/svg+xml,%3Csvg width='127' height='32' viewBox='0 0 127 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.8967 0.010939L20.1256 2.85504V18.3869L13.8967 21.8816V0.010939ZM11.4421 24.2637V32L0.44433 26.0763L0 18.0909L11.4421 24.2637ZM11.3729 14.1568V21.9877L0.44433 15.7571V8.1739L11.3729 14.1568ZM24.6844 25.9572L13.8269 31.881V24.2038L24.6844 18.1849V25.9572ZM11.3018 11.859L4.383 8.30516L4.7099 3.02105L11.3018 0V11.859Z' fill='%2304416D'/%3E%3Cpath d='M126.957 12.2588H122.689C122.611 11.7067 122.452 11.2163 122.212 10.7875C121.972 10.3523 121.663 9.9821 121.286 9.67681C120.91 9.37151 120.474 9.13767 119.981 8.97529C119.494 8.8129 118.964 8.7317 118.393 8.7317C117.36 8.7317 116.46 8.98828 115.694 9.50142C114.927 10.0081 114.333 10.7486 113.911 11.7229C113.488 12.6907 113.277 13.8664 113.277 15.25C113.277 16.6725 113.488 17.8677 113.911 18.8356C114.339 19.8034 114.937 20.5341 115.703 21.0278C116.47 21.5215 117.357 21.7683 118.363 21.7683C118.928 21.7683 119.451 21.6936 119.932 21.5442C120.419 21.3948 120.851 21.1772 121.228 20.8914C121.605 20.5991 121.916 20.2451 122.163 19.8294C122.417 19.4137 122.592 18.9395 122.689 18.4068L126.957 18.4263C126.847 19.3422 126.57 20.2256 126.129 21.0765C125.694 21.9209 125.106 22.6777 124.365 23.3467C123.631 24.0093 122.754 24.5354 121.735 24.9251C120.721 25.3084 119.575 25.5 118.295 25.5C116.515 25.5 114.924 25.0973 113.521 24.2918C112.124 23.4864 111.02 22.3204 110.208 20.794C109.403 19.2675 109 17.4195 109 15.25C109 13.074 109.409 11.2227 110.228 9.69629C111.046 8.16983 112.157 7.00713 113.56 6.20818C114.963 5.40273 116.541 5 118.295 5C119.451 5 120.523 5.16239 121.51 5.48717C122.504 5.81195 123.384 6.28612 124.151 6.9097C124.917 7.52677 125.541 8.28351 126.022 9.1799C126.509 10.0763 126.821 11.1026 126.957 12.2588Z' fill='%2304416D'/%3E%3Cpath d='M64.4479 9.71641H70.3689V6H53.9469V9.71641H59.7297V26H64.4479V9.71641Z' fill='%2304416D'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M42.2784 22.26H48.801L49.946 25.9994H55.1039L47.7716 6.00064H43.2965L36.0339 25.9994H41.1221L42.2784 22.26ZM43.4235 18.5436H47.6561L45.5282 11.6036L43.4235 18.5436Z' fill='%2304416D'/%3E%3Cpath d='M88.0972 9.71641H82.1763V26H77.4235V9.71641H71.6408V6H88.0972V9.71641Z' fill='%2304416D'/%3E%3Cpath d='M90 6H94.2188V18.5781H94.3848L103.027 6H106.729V26H102.5V13.4121H102.354L93.6621 26H90V6Z' fill='%2304416D'/%3E%3C/svg%3E");
        background-size: contain;
        background-repeat: no-repeat;
    } */
header .flag {
  background-image: url("data:image/svg+xml,%3Csvg width='36' height='32' viewBox='0 0 36 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cmask id='mask0_353_12184' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='6' y='6' width='24' height='20'%3E%3Crect x='6' y='6' width='24' height='20' rx='4' fill='%23D9D9D9'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_353_12184)'%3E%3Crect x='6' y='19.333' width='24' height='6.66667' fill='%23D80027'/%3E%3Crect x='6' y='12.667' width='24' height='6.66667' fill='%230052B4'/%3E%3Crect x='6' y='6' width='24' height='6.66667' fill='%23F0F0F0'/%3E%3C/g%3E%3C/svg%3E");
  width: 36px;
  height: 32px;
  margin-left: 10px;
  background-repeat: no-repeat;
  background-size: contain;
}
header .nav-link {
  color: #797980;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.text-primary {
  color: var(--color1) !important;
}
.btn-primary {
  background: linear-gradient(90deg, var(--color1) 0%, var(--color2) 100%) !important;
  border: 0 !important;
}
body {
  background-color: #f9fafa !important;
}
article {
  background-color: #f9fafa !important;
  padding-bottom: 60px;
}
.hero {
  height: 514px;
  background-color: #f9fafa;
  background-position: bottom right;
  background-repeat: no-repeat;
  background-image: url("./newhomepage/hero.png");
  /* background: linear-gradient(90deg, #F9FAFA 1.42%, rgba(249, 250, 250, 0) 36.36%), linear-gradient(180deg, rgba(249, 250, 250, 0) 66.07%, #F9FAFA 88.42%), url('./hero.png') no-repeat -50% bottom; */
  background-blend-mode: normal, normal, multiply;
}
.hero h1 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 60px;
  /* or 125% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* attis/primary */

  color: #04416d;
  max-width: 950px;
}
.hero h3 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 44px;
  /* or 122% */

  display: flex;
  align-items: center;

  /* attis/secondary */

  color: var(--color2);

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
  max-width: 480px;
}
.partners {
  padding: 60px 0;
}
.partners h5 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 36px;
  /* identical to box height, or 129% */

  /* attis/primary */

  color: #04416d;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  margin-bottom: 24px;
}
.card {
  background: #ffffff;
  /* backdrop-filter: blur(20px); */
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 40px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  z-index: 1;
  box-shadow: none;
}
.card-body {
  padding: 40px;
  padding-bottom: 0;
}
.card-footer {
  padding: 40px;
  padding-top: 40px;
  background-color: transparent;
}
.card .card-body h5 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 36px;
  /* or 129% */

  /* attis/primary */

  color: #04416d;
}
.card .card-body ul {
  margin-left: 0;
  /* padding-inline: 1rem; */
}
.card .card-body li {
  padding-left: 10px;
  display: flex;
  margin-bottom: 5px;
}
.card .card-body ul {
  list-style: none; /* Remove default bullets */
}

.card .card-body ul li::before {
  content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
  font-size: 1.5em;
  color: #04416d; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  margin-right: 1em;
  margin-left: -2em; /* Also needed for space (tweak if needed) */
}
.card .card-body li,
.card .card-body p {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* neutral/30 */

  color: #797980;
}
.card .card-footer .prices-block {
  display: flex;
  flex-wrap: nowrap;
  align-items: end;
}
.card .card-footer .ordinary-price {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height, or 120% */

  /* neutral/30 */

  color: #797980;
}
.card .card-footer .privileged-price {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  margin-left: 5px;
  /* identical to box height, or 117% */

  /* attis/primary */

  color: #04416d;
}
.card .card-footer .privileged-price small {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 24px;
  margin-left: 5px;
  /* identical to box height, or 150% */
  white-space: nowrap;

  letter-spacing: 0.1px;

  /* attis/primary */

  color: #04416d;
}
.card .card-footer .qty-block {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  letter-spacing: 0.25px;

  /* neutral/30 */

  color: #797980;
  margin-top: 10px;
}
.banner .banner-inner {
  margin: 60px 0;
  padding: 40px 44px;
  /* primary/primary */
  min-height: 348px;
  background-color: #fe5000;

  background-repeat: no-repeat;

  box-shadow:
    0px 30px 40px rgba(254, 80, 0, 0.16),
    0px 40px 60px rgba(254, 80, 0, 0.1);
  border-radius: 40px;
  position: relative;
}
.banner .banner-inner .banner-attis-bg {
  background-image: url("./newhomepage/atb_logo_banner.png");
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  border-radius: 40px;
  opacity: 0.1;
  background-repeat: no-repeat;
  background-position: bottom right;
}
.banner .banner-contents {
  z-index: 3;
  position: absolute;
  left: 40px;
  right: 40px;
  bottom: 40px;
  top: 40px;
}
.banner-top {
  align-items: center;
}
.banner-top img {
  display: block;
}
.banner-top > div > div {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 36px;
  /* or 129% */

  /* primary100 */
  margin-left: 15px;
  color: #ffffff;
}
.banner-middle {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  /* primary100 */

  color: #ffffff;
}
.btn-white.text-warning {
  color: #fe5000 !important;
  /* Title/Medium */

  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.1px;
}
.btn-white.text-warning i,
.btn-transparent i,
.btn-white.text-warning svg,
.btn-transparent svg {
  margin-left: 15px;
}
.contact-form-title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 44px;
  line-height: 56px;
  /* identical to box height, or 127% */

  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 80px;
  justify-content: center;

  /* attis/primary */

  color: #04416d;
}
.form-group {
  position: relative;
  border: 1px solid #b1b1b1;
  border-radius: 4px;
  height: 56px;
  margin-top: 20px;
  margin-bottom: 36px;
}
.form-group.textarea {
  height: 112px;
}
.form-group .form-control {
  border: 0;
  height: 50px;
  position: absolute;
  box-shadow: none !important;
  outline: none !important;
}
.form-group textarea.form-control {
  height: 104px;
}
.form-group label {
  font-family: "Roboto";
  padding: 0 4px;
  background-color: #fff;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  position: absolute;
  left: 16px;
  z-index: 3;
  top: -8px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
}
.form-group.checkbox {
  border: 0;

  justify-content: flex-starts;
}
.form-group.checkbox input {
  position: relative;
  height: 24px;
  width: 24px;
  margin-right: 15px;
}
.form-group.checkbox label {
  position: relative;
  display: flex;
  left: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  display: flex;
  align-items: start;

  /* neutral/10 */

  color: #333333;
}
.form-group.button {
  border: 0;
  margin-bottom: 80px;
}
.form-group.button button svg,
.form-group.button button i {
  margin-left: 15px;
}
footer {
  background-color: #333333;
}
footer .logo {
  width: 127px;
  height: 32px;
  background-image: url("data:image/svg+xml,%3Csvg width='127' height='32' viewBox='0 0 127 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.8967 0.010939L20.1256 2.85504V18.3869L13.8967 21.8816V0.010939ZM11.4421 24.2637V32L0.44433 26.0763L0 18.0909L11.4421 24.2637ZM11.3729 14.1568V21.9877L0.44433 15.7571V8.1739L11.3729 14.1568ZM24.6844 25.9572L13.8269 31.881V24.2038L24.6844 18.1849V25.9572ZM11.3018 11.859L4.383 8.30516L4.7099 3.02105L11.3018 0V11.859Z' fill='%23B1B1B1'/%3E%3Cpath d='M126.957 12.2588H122.689C122.611 11.7067 122.452 11.2163 122.212 10.7875C121.972 10.3523 121.663 9.9821 121.286 9.67681C120.91 9.37151 120.474 9.13767 119.981 8.97529C119.494 8.8129 118.964 8.7317 118.393 8.7317C117.36 8.7317 116.46 8.98828 115.694 9.50142C114.927 10.0081 114.333 10.7486 113.911 11.7229C113.488 12.6907 113.277 13.8664 113.277 15.25C113.277 16.6725 113.488 17.8677 113.911 18.8356C114.339 19.8034 114.937 20.5341 115.703 21.0278C116.47 21.5215 117.357 21.7683 118.363 21.7683C118.928 21.7683 119.451 21.6936 119.932 21.5442C120.419 21.3948 120.851 21.1772 121.228 20.8914C121.605 20.5991 121.916 20.2451 122.163 19.8294C122.417 19.4137 122.592 18.9395 122.689 18.4068L126.957 18.4263C126.847 19.3422 126.57 20.2256 126.129 21.0765C125.694 21.9209 125.106 22.6777 124.365 23.3467C123.631 24.0093 122.754 24.5354 121.735 24.9251C120.721 25.3084 119.575 25.5 118.295 25.5C116.515 25.5 114.924 25.0973 113.521 24.2918C112.124 23.4864 111.02 22.3204 110.208 20.794C109.403 19.2675 109 17.4195 109 15.25C109 13.074 109.409 11.2227 110.228 9.69629C111.046 8.16983 112.157 7.00713 113.56 6.20818C114.963 5.40273 116.541 5 118.295 5C119.451 5 120.523 5.16239 121.51 5.48717C122.504 5.81195 123.384 6.28612 124.151 6.9097C124.917 7.52677 125.541 8.28351 126.022 9.1799C126.509 10.0763 126.821 11.1026 126.957 12.2588Z' fill='%23B1B1B1'/%3E%3Cpath d='M64.4479 9.71641H70.3689V6H53.9469V9.71641H59.7297V26H64.4479V9.71641Z' fill='%23B1B1B1'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M42.2784 22.26H48.801L49.946 25.9994H55.1039L47.7716 6.00064H43.2965L36.0339 25.9994H41.1221L42.2784 22.26ZM43.4235 18.5436H47.6561L45.5282 11.6036L43.4235 18.5436Z' fill='%23B1B1B1'/%3E%3Cpath d='M88.0972 9.71641H82.1763V26H77.4235V9.71641H71.6408V6H88.0972V9.71641Z' fill='%23B1B1B1'/%3E%3Cpath d='M90 6H94.2188V18.5781H94.3848L103.027 6H106.729V26H102.5V13.4121H102.354L93.6621 26H90V6Z' fill='%23B1B1B1'/%3E%3C/svg%3E");
}
footer .nav-link {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.1px;

  /* neutral/70 */

  color: #b1b1b1;
}
footer .copy-right-section {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  /* primary100 */
  margin-top: 34px;
  color: #ffffff;
}
footer .copy-right-section a {
  color: #b1b1b1;
}
footer {
  padding: 50px 0;
}
@media screen and (max-width: 768px) {
  .hero h1 {
    font-size: 28px;
    line-height: 40px;
  }
  .hero h3 {
    font-size: 26px;
    line-height: 34px;
  }
  .banner-top > .d-flex {
    display: block !important;
  }
  .partners > .container > .d-flex,
  .services > .container > .d-flex {
    display: block !important;
  }
  .partners img,
  .services img,
  .banner-top img {
    max-width: 100%;
  }
  .banner-top > div > div {
    font-size: 18px;
    margin-left: 0;
    line-height: 24px;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .banner .banner-contents {
    position: relative;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
  }
  .contact-form .card-body {
    padding: 10px;
  }
  .card .card-footer .prices-block,
  .card .card-footer .prices-block span {
    display: block;
  }

  footer .d-flex.align-items-center {
    display: block !important;
  }
  footer .d-flex.align-items-center .ml-auto {
    margin-left: 0 !important;
  }
  footer .copy-right-section {
    flex-direction: column-reverse;
  }
  footer .copy-right-section > div:nth-child(2) {
    margin-bottom: 15px;
  }
  .right-20 {
    right: 20px;
  }
  .top-20 {
    top: 20px;
  }
  .partners > .container > .d-flex > div {
    text-align: center !important;
    margin-block: 30px;
  }
  .partners > .container h5 {
    text-align: center;
  }
  .partners img {
    width: 60%;
  }
  .services .card {
    margin-bottom: 20px;
  }
  .banner-contents .btn.btn-white {
    white-space: nowrap;
    margin-top: 40px;
  }
  .contact-form-title {
    font-size: 24px;
    margin-top: 20px;
  }
  .form-group.button {
    margin-bottom: 20px;
  }
}
.gap-20 {
  gap: 20px;
}
footer .copy-right-section a {
  text-decoration: underline;
  color: #fff;
}
.form-group input::-webkit-input-placeholder,
.form-group input:-ms-input-placeholder,
.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #797980;
}
.flag-dd {
  position: absolute;
  left: 150px;
  top: 60px;
}
</style>
